module.exports = __webpack_public_path__ + "/img/ChipArray2SideFlat-Custom-Footprint-wjUM60.svg";